import { createRouter, createWebHistory } from 'vue-router';
import { getAuth } from "firebase/auth";

import homePage from './pages/HomePage.vue';
import AccountPage from './pages/AccountPage.vue';
import DocsPage from './pages/DocsPage.vue';
import LoginButton from "./components/LoginButton.vue";
const routes = [
  {
    path: '/',
    name: 'Home',
    component: homePage,
    meta: { requiresAuth: true } // This indicates that this route requires authentication
  },
  {
    path: '/Docs',
    name: 'Docs',
    component: DocsPage,
    // meta: { requiresAuth: true } // This indicates that this route requires authentication
  },
  {
    path: '/Account',
    name: 'Account',
    component: AccountPage,
    meta: { requiresAuth: true } // This indicates that this route requires authentication
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginButton,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = getAuth().currentUser;

  if (requiresAuth && !isAuthenticated) {
    next('/login');  // redirect to login page
  } else if (to.path === '/login' && isAuthenticated) {
    next('/');  // if already logged in, redirect to home page
  } else {
    next(); // go to the requested route
  }
});

export default router;
